/**
 * Syncs the derived `RuleContext` into the rule store. `ctx` is low-frequency
 * (mode / isEdit / hasEntityId / planYear) and is derived by the caller from
 * route/props/React Query/session, then mirrored here so the engine can
 * evaluate `ctx:*` conditions uniformly with field values.
 */
import { useEffect } from 'react';

import type { RuleContext } from '../types';
import { useRuleStore } from '../store/selectors';

export function useSyncRuleContext(ctx: RuleContext): void {
    const setContext = useRuleStore((s) => s.setContext);

    useEffect(() => {
        setContext(ctx);
        // Sync on the primitive context fields the engine reads; the caller keeps
        // `ctx` derivation cheap so this fires only on real mode transitions.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [setContext, ctx.mode, ctx.isEdit, ctx.hasEntityId, ctx.planYear]);
}
